import { render, staticRenderFns } from "./ProcessesPage.vue?vue&type=template&id=58d472d1&scoped=true&"
import script from "./ProcessesPage.vue?vue&type=script&lang=js&"
export * from "./ProcessesPage.vue?vue&type=script&lang=js&"
import style0 from "./ProcessesPage.vue?vue&type=style&index=0&id=58d472d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d472d1",
  null
  
)

export default component.exports